import DebotorsAndCreaditorsUpperComponent from "components/Reports/AccountCard/DebotorsAndCreaditorsUpperComponent";
import Table from "components/Table";

export default function DebtorsCreditors() {
    return (
        <div className="warp-debtor-creaditor">
            <Table type="debtorsAndCreditors" sumAmountInfo={[
                {
                    name: "debtor", isCurrency: true,
                },
                {
                    name: "credit", isCurrency: true,
                },
                {
                    name: "balance", isCurrency: true,
                },
            ]} MidComponent={DebotorsAndCreaditorsUpperComponent as any} />
        </div>
    );
}
